import React from 'react';

import { Box } from '@mui/material';
import MetricsLogoTrans from '../../assets/images/DGV_Metrics_Logo.png';


const topNavSize = {
    height: 33,
    width: 176,
    maxHeight: { xs: 33, md: 33 },
    maxWidth: { xs: 176, md: 176 },
    mb: 0
} as const;

const defaultSize = {
    height: 45,
    width: 240,
    maxHeight: { xs: 45, md: 45 },
    maxWidth: { xs: 240, md: 240 },
    mb: 3,
} as const;


function DGVMetricsLogo({ topNavLogo }: { topNavLogo: boolean }) {
    return (
        <Box
            component="img"
            sx={[
                { ...defaultSize },
                topNavLogo && { ...topNavSize }
            ]}
            alt='DGV Metrics Logo'
            src={MetricsLogoTrans}
        />
    )
}

export default DGVMetricsLogo
